import slug from 'constants/slug'
import createBreadcrumb from 'shared/breadcrumb/hoc'
//import Icon from 'themes/icon'

export default createBreadcrumb({
  list: {
    id: 'list',
    //icon: Icon.car,
    href: slug.organization.list,
    name: 'Organization'
  },
  create: {
    id: 'create',
    href: slug.organization.create,
    name: 'Create'
  },
  edit: {
    href: slug.organization.edit,
    name: 'Update'
  },
  rule: {
    href: slug.organization.rule,
    name: 'Update Rule'
  }
})



// WEBPACK FOOTER //
// ./src/containers/organization/breadcrumb.js